class Accordion extends HTMLElement {

    constructor() {
        super()
        this.init()
    }

    private init() {
        this.initClickEvent()
        this.activeFirstItem()
    }

    private initClickEvent() {
        const accordionList = this.querySelector('.accordion-js-list');

        if (!accordionList) {return}

        accordionList.addEventListener('click', (event) => {
            const target = (event.target instanceof Element)
                ? event.target.closest('.accordion-js-title') as HTMLButtonElement | null
                : null;
            if (target && target.classList.contains('accordion-js-title')) {
                event.preventDefault(); // Prevenir comportamiento por defecto
                event.stopPropagation(); // Prevenir propagación
                
                const parent = target.closest('.accordion-js-item');
                const content = parent?.querySelector('.accordion-js-content') as HTMLElement | null;
                if (content) {
                    content.classList.contains('active') ? this.close(target, content) : this.open(target, content);
                }
            }
        });
    }

    private activeFirstItem() {
        if ( this.dataset.openFirstItem !== 'true') {return}

        const buttons = this.querySelectorAll('.accordion-js-title')
        const dropdowns = this.querySelectorAll('.accordion-js-content')

        const buttonActive = <HTMLButtonElement>buttons[0]
        const dropDownActive = <HTMLElement>dropdowns[0]

        // Esperar a que el contenido esté completamente renderizado antes de abrir
        if (document.readyState === 'complete') {
            // Si el documento ya está cargado, usar requestAnimationFrame para asegurar renderizado
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    this.open(buttonActive, dropDownActive);
                });
            });
        } else {
            // Si aún se está cargando, esperar al evento load
            window.addEventListener('load', () => {
                requestAnimationFrame(() => {
                    requestAnimationFrame(() => {
                        this.open(buttonActive, dropDownActive);
                    });
                });
            }, { once: true });
        }
    }
    
    private open (button: HTMLElement, dropDown: HTMLElement) {
        // Guardar posición de scroll actual para evitar saltos
        const scrollPosition = window.scrollY || window.pageYOffset;
        
        this.closeAllDrops(button, dropDown);
        
        // Forzar reflow para asegurar que el contenido esté medido correctamente
        dropDown.style.display = 'block';
        dropDown.style.height = '0px';
        dropDown.offsetHeight; // Force reflow
        
        // Calcular altura correcta
        const targetHeight = dropDown.scrollHeight;
        dropDown.style.height = targetHeight + 'px';
        button.classList.add('active');
        dropDown.classList.add('active');
        
        // Restaurar posición de scroll para evitar saltos
        requestAnimationFrame(() => {
            window.scrollTo(0, scrollPosition);
        });
        
        // Después de la transición, cambiar a auto para contenido dinámico
        setTimeout(() => {
            if (dropDown.classList.contains('active')) {
                dropDown.style.height = 'auto';
            }
        }, 400);
    }

    private close (button: HTMLElement, dropDown: HTMLElement) {
        // Si está en auto, establecer altura actual primero
        if (dropDown.style.height === 'auto' || dropDown.style.height === '') {
            dropDown.style.height = dropDown.scrollHeight + 'px';
            dropDown.offsetHeight; // Force reflow
        }
        
        // Animar a 0
        requestAnimationFrame(() => {
            dropDown.style.height = '0px';
            button.classList.remove('active');
            dropDown.classList.remove('active');
            
            // Limpiar altura después de la transición
            setTimeout(() => {
                if (!dropDown.classList.contains('active')) {
                    dropDown.style.height = '';
                    dropDown.style.display = '';
                }
            }, 400);
        });
    }

    private closeAllDrops (button: HTMLElement, dropDown: HTMLElement) {
        const accordionListItems = this.querySelectorAll('.accordion-js-item')
        accordionListItems.forEach((elem) => {
            const btn = <HTMLElement>elem.children[0]
            const drop = <HTMLElement>elem.children[1]
            if (btn !== button && drop !== dropDown) {
                this.close(btn, drop);
            }
        })
    }
}

export default Accordion